export default __webpack_public_path__ + "static/media/wwf_mobile_small.2346ef69.jpg";